import type { TemplateType } from "@/api";
import { cn } from "@/lib/utils";
import { templateTypes } from "@/lib/domain";

/** Type chooser: one chip per Type with its one-line meaning. */
export function TypeChips({
  value,
  onChange,
}: {
  value: TemplateType | null;
  onChange: (value: TemplateType) => void;
}) {
  return (
    <div className="flex flex-wrap gap-2" role="radiogroup" aria-label="Type">
      {templateTypes.map((t) => {
        const on = value === t.value;
        return (
          <button
            key={t.value}
            type="button"
            role="radio"
            aria-checked={on}
            onClick={() => onChange(t.value)}
            className={cn(
              "rounded-lg border px-3 py-1.5 text-left text-sm transition-colors",
              on
                ? "border-primary bg-primary text-primary-foreground"
                : "border-border bg-card text-foreground hover:bg-secondary",
            )}
          >
            <span className="font-medium">{t.label}</span>
            <span className={cn("block text-xs", on ? "opacity-80" : "text-muted-foreground")}>
              {t.hint}
            </span>
          </button>
        );
      })}
    </div>
  );
}
